import { Box, LinearProgress, Typography } from '@mui/material'
import dayjs from "dayjs/dayjs.min"

const TrackingKeywordToday = ({ data }) => {
  if (!data) {
    return null;
  }

  let color = 'black';

  if (data.history && data.history.length > 1) {
    data.history = data.history.sort(
      (a, b) => dayjs(b.date).valueOf() - dayjs(a.date).valueOf()
    );

    const firstValue = data.history[0].rankGroup;
    const secondValue = data.history[1].rankGroup;
    if(firstValue < secondValue) {
      color =  'green'
    } else if (firstValue > secondValue) {
      color = 'red'
    }
  }
  
  const diff = data.history && data.history.length > 1
    ? data.history[0].rankGroup - data.history[1].rankGroup
    : 0;
  
  const formattedDiff = diff > 0 ? `+${diff}` : `${diff}`;
  return (
    <>
      {data.history == null ? (
        <LinearProgress sx={{ width: '20px', height: '4px', backgroundColor: 'transparent', '& .MuiLinearProgress-bar': { backgroundColor: color } }} />
      ) : (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
          <Typography sx={{ mr: 2 }}>
            {data.history[0]?.rankGroup === -1 ? 'n/a' : data.history[0]?.rankGroup}
          </Typography>
          {data.history.length > 1 &&
            data.history[0]?.rankGroup !== undefined &&
            data.history[1]?.rankGroup !== undefined &&
            diff !== 0 && (
              <Typography
                component="span"
                color={color}
                sx={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  fontSize: '0.75rem',
                  lineHeight: 1,
                  fontWeight: 900,
                  color: color,
                }}
              >
                {formattedDiff}
              </Typography>
            )}
        </Box>


      )}
    </>
  );
};

export default TrackingKeywordToday;